<script setup>
import Button from 'dashboard/components-next/button/Button.vue';
import BackButton from 'dashboard/components/widgets/BackButton.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import PaginationFooter from 'dashboard/components-next/pagination/PaginationFooter.vue';
import Policy from 'dashboard/components/policy.vue';

defineProps({
  headerTitle: {
    type: String,
    default: '',
  },
  backUrl: {
    type: [String, Object],
    default: '',
  },
  buttonLabel: {
    type: String,
    default: '',
  },
  buttonPolicy: {
    type: Array,
    default: () => ['administrator', 'agent'],
  },
  isFetching: {
    type: Boolean,
    default: false,
  },
  isEmpty: {
    type: Boolean,
    default: false,
  },
  showPaginationFooter: {
    type: Boolean,
    default: false,
  },
  currentPage: {
    type: Number,
    default: 1,
  },
  totalCount: {
    type: Number,
    default: 0,
  },
  itemsPerPage: {
    type: Number,
    default: 25,
  },
});

const emit = defineEmits(['click', 'update:currentPage']);
</script>

<template>
  <section class="flex flex-col w-full h-full overflow-hidden bg-n-surface-1">
    <header class="sticky top-0 z-10 px-6">
      <div class="w-full max-w-5xl mx-auto">
        <div
          class="flex items-center justify-between w-full py-6 lg:py-0 lg:h-20 gap-4"
        >
          <div class="flex gap-3 items-center">
            <BackButton v-if="backUrl" :back-url="backUrl" />
            <span
              v-if="headerTitle"
              class="text-xl font-medium text-n-slate-12"
            >
              {{ headerTitle }}
            </span>
          </div>
          <div class="flex gap-2">
            <slot name="actions" />
            <Policy v-if="buttonLabel" :permissions="buttonPolicy">
              <Button
                :label="buttonLabel"
                icon="i-lucide-plus"
                size="sm"
                @click="emit('click')"
              />
            </Policy>
          </div>
        </div>
      </div>
    </header>
    <main class="flex-1 px-6 overflow-y-auto">
      <div class="w-full max-w-5xl h-full mx-auto py-4">
        <div
          v-if="isFetching"
          class="flex items-center justify-center py-10 text-n-slate-11"
        >
          <Spinner />
        </div>
        <div
          v-else-if="isEmpty"
          class="flex flex-col items-center justify-center min-h-80 gap-2 text-center"
        >
          <slot name="emptyState" />
        </div>
        <slot v-else name="body" />
      </div>
    </main>
    <footer v-if="showPaginationFooter" class="sticky bottom-0 z-10">
      <PaginationFooter
        :current-page="currentPage"
        :total-items="totalCount"
        :items-per-page="itemsPerPage"
        class="max-w-[67rem]"
        @update:current-page="emit('update:currentPage', $event)"
      />
    </footer>
  </section>
</template>
